import React, { useContext, useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';
import { DocumentsContext } from 'context/DocumentsContext';
import { InformationDashboard409AContext } from 'context/InformationDashboard409AContext';
import { RequestedFile } from 'pages/RequestDocuments/components/FolderIcon/types';
import DocumentActionButtons from './DocumentActionButtons';
import PendingDocumentTable from './PendingDocumentTable';
import { CurrentRequestedDocumentTablesProps } from './types';
import UploadedDocumentsTable from './UploadedDocumentsTable';

const CurrentRequestedDocumentTables = ({ documents }: CurrentRequestedDocumentTablesProps) => {
  const { handleGetCurrentInformationRequests, currentDocuments, refreshDocuments, permissions } = useContext(
    InformationDashboard409AContext
  );
  const [uploadedFiles, setUploadedFiles] = useState<RequestedFile[]>([]);
  const unmetRequests = useMemo(() => documents?.progress.filter(request => (request.files?.length ?? 0) === 0), [documents]);
  const documentsContextValue = useMemo(() => ({ currentDocuments }), [currentDocuments]);

  useEffect(() => {
    refreshDocuments();
    handleGetCurrentInformationRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedFiles]);

  return (
    <DocumentsContext.Provider value={documentsContextValue}>
      {!isEmpty(unmetRequests) && permissions?.canUseInfoRequestLedger && (
        <PendingDocumentTable documents={documents} unmetRequests={unmetRequests} setUploadedFiles={setUploadedFiles} />
      )}
      {!isEmpty(currentDocuments) && (
        <DocumentActionButtons
          currentDocuments={{ ...currentDocuments, files: currentDocuments.files ?? [] }}
        />
      )}
      <UploadedDocumentsTable documents={documents} />
    </DocumentsContext.Provider>
  );
};

export default CurrentRequestedDocumentTables;
